import LegalShell from "./LegalShell";

export default function KVKK() {
    return (
        <LegalShell
            title="KVKK Aydınlatma Metni"
            subtitle="6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında Sayz hizmetleri için veri sorumlusu sıfatıyla yürütülen aydınlatma metnidir."
            lastUpdated="24 Şubat 2026"
            testId="legal-kvkk"
        >
            <p className="lead">
                Sayz, Atamis Global Teknoloji A.Ş. tarafından yürütülen bir SaaS hizmetidir
                ve e-ticaret siteleri için beden tablosu/bedenimi bul widget'ları sunar.
                Hizmetlerimizi kullanırken işlenen kişisel verileriniz 6698 sayılı Kişisel
                Verilerin Korunması Kanunu ("KVKK") kapsamında aşağıdaki esaslara uygun
                olarak işlenmektedir.
            </p>

            <h2>1. Veri Sorumlusu</h2>
            <p>
                <strong>Atamis Global Teknoloji A.Ş.</strong> (bundan sonra "Sayz" olarak
                anılacaktır), KVKK kapsamında <strong>Veri Sorumlusu</strong> olarak
                hareket etmektedir. İletişim: <a href="mailto:hello@atamis.global">hello@atamis.global</a>.
            </p>

            <h2>2. İşlenen Kişisel Veri Kategorileri</h2>

            <h3>a) Müşteri (Merchant) kullanıcıları</h3>
            <ul>
                <li><strong>Kimlik:</strong> ad, soyad, e-posta adresi</li>
                <li><strong>İletişim:</strong> telefon (opsiyonel), kurumsal e-posta</li>
                <li><strong>Hesap güvenliği:</strong> OTP doğrulama kayıtları, oturum IP/UA bilgileri</li>
                <li><strong>Finansal:</strong> fatura bilgileri (unvan, vergi numarası, adres)</li>
                <li><strong>Denetim kayıtları:</strong> panelde yapılan destructive işlemlerin audit log'u</li>
            </ul>

            <h3>b) Son ziyaretçi (End User) verileri</h3>
            <p>
                Sayz widget'ının yüklendiği merchant sitelerinde ziyaretçilerin "Bedenimi Bul"
                akışında girdiği aşağıdaki veriler <strong>anonim ölçüm verisi</strong>
                olarak işlenir ve kimlik tespiti yapılamaz:
            </p>
            <ul>
                <li>Boy, kilo, yaş aralığı</li>
                <li>Vücut tipi tercihleri (göğüs/bel/kalça)</li>
                <li>Fit tercihi (dar/normal/bol)</li>
                <li>Önerilen beden sonucu + merchant tarafından yapılan satın alma dönüşüm sinyali</li>
            </ul>
            <p>
                Bu veriler yalnızca <strong>Smart Recall</strong> özelliği için ziyaretçinin
                kendi tarayıcısındaki <code>localStorage</code>'da saklanır; Sayz sunucularına
                aktarılmaz. Sadece ürün bazlı anonimleştirilmiş etkileşim sayaçları
                (<code>widget_events</code>, <code>widget_query_log</code>) merchant'ın
                analiz paneli için merkezi veritabanına yazılır.
            </p>

            <h2>3. Kişisel Verilerin İşlenme Amaçları</h2>
            <ul>
                <li>Hizmet sözleşmesinin ifası ve müşteri panelinin işletilmesi</li>
                <li>OTP ile kimlik doğrulama ve hesap güvenliği</li>
                <li>Teknik destek ve müşteri hizmetleri</li>
                <li>Yasal zorunlulukların yerine getirilmesi (fatura, vergi)</li>
                <li>Hizmetin iyileştirilmesi için anonimleştirilmiş kullanım istatistikleri</li>
                <li>Dolandırıcılık önleme ve denetim kayıtları</li>
            </ul>

            <h2>4. Hukuki Sebepler</h2>
            <ul>
                <li>Sözleşmenin kurulması veya ifası için gerekli olması (KVKK m.5/2-c)</li>
                <li>Veri sorumlusunun hukuki yükümlülüğünün yerine getirilmesi (KVKK m.5/2-ç)</li>
                <li>İlgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla meşru menfaatlerin yerine getirilmesi (KVKK m.5/2-f)</li>
                <li>Açık rıza (Smart Recall opsiyonel çerezleri ve pazarlama iletişimleri için)</li>
            </ul>

            <h2>5. Kişisel Verilerin Aktarılması</h2>
            <p>
                Verileriniz yalnızca aşağıdaki hallerde ve yalnızca gerekli olduğu ölçüde paylaşılır:
            </p>
            <ul>
                <li><strong>Altyapı sağlayıcıları:</strong> AWS, Emergent Platform (barındırma; AB/ABD veri merkezleri)</li>
                <li><strong>E-posta iletim sağlayıcıları:</strong> OTP kodlarının iletilmesi için</li>
                <li><strong>Hata izleme (opsiyonel):</strong> Sentry (anonimleştirilmiş hata stack trace)</li>
                <li><strong>Yasal yükümlülük:</strong> yetkili kamu kurum ve kuruluşları</li>
            </ul>
            <p>
                Verileriniz hiçbir şekilde reklam ağlarıyla, veri komisyoncularıyla veya yasal
                dayanağı olmayan üçüncü taraflarla paylaşılmaz.
            </p>

            <h2>6. Veri Saklama Süreleri</h2>
            <ul>
                <li>Hesap bilgileri: sözleşmenin devamı + yasal zamanaşımı (10 yıl ticari defter saklama)</li>
                <li>Audit log: 24 ay</li>
                <li>Widget query log: 30 gün (otomatik anonimleştirilmiş aggregate'e dönüşür)</li>
                <li>Smart Recall ziyaretçi profili: ziyaretçinin kendi tarayıcısında, kullanıcı silene kadar</li>
            </ul>

            <h2>7. KVKK Madde 11 Kapsamındaki Haklarınız</h2>
            <ul>
                <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
                <li>İşlenmişse buna ilişkin bilgi talep etme</li>
                <li>İşlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
                <li>Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme</li>
                <li>Eksik veya yanlış işlenmiş olması halinde düzeltilmesini isteme</li>
                <li>Silinmesini veya yok edilmesini isteme</li>
                <li>Otomatik sistemler vasıtasıyla analiz edilmesine itiraz etme</li>
                <li>Kanuna aykırı işleme sebebiyle zarara uğraması halinde zararın giderilmesini talep etme</li>
            </ul>

            <h2>8. Başvuru Yöntemi</h2>
            <p>
                Haklarınızı kullanmak için talebinizi kimliğinizi tevsik eden belgelerle birlikte{" "}
                <a href="mailto:hello@atamis.global">hello@atamis.global</a> adresine iletebilirsiniz.
                Başvurular yasal süresi içinde ücretsiz olarak sonuçlandırılır (KVKK m.13).
            </p>
        </LegalShell>
    );
}
